import React, { FC, memo, useCallback } from 'react';
import styled from 'styled-components';
import { useDataTableContext } from '../../utils/DataTableContext';
import { SearchInput, SearchInputProps } from './Search';
import { useDataTableQueryContext } from '../../utils/DataTableQueryProvider/DataTableQueryProvider';

export const DataTableSearchComponent: FC<React.PropsWithChildren<SearchInputProps>> = ({
  onValueChange,
  width,
  value,
  ...searchProps
}) => {
  const { applyQuery, queryVariables } = useDataTableQueryContext();
  // @ts-ignore because of smart-forms
  const { gotoPage, toggleAllRowsExpanded } = useDataTableContext();

  const onValueChangeHandler = useCallback(
    (name: string) => {
      applyQuery(
        {
          search: name || ''
        },
        {
          mode: 'patch',
          persist: true
        }
      );
      onValueChange?.(name);
      gotoPage?.(0);
      toggleAllRowsExpanded?.(true);
    },
    [applyQuery, gotoPage, onValueChange, toggleAllRowsExpanded]
  );
  return (
    <StyledSearchInputWrapper>
      <SearchInput
        {...searchProps}
        value={queryVariables?.query?.search || ''}
        onValueChange={onValueChangeHandler}
        width={width || '220px'}
      />
    </StyledSearchInputWrapper>
  );
};

export const DataTableSearch = memo(DataTableSearchComponent);

const StyledSearchInputWrapper = styled.div`
  margin: 0 ${({ theme }) => theme.spacingSize.l};
`;
